import React from "react";

import { BettingTypeColumnTip } from "./BettingTypeColumnTip";

export function BettingTypeColumnTips(props: { tips: string[] }) {
	const { tips } = props;

	return (
		<>
			{tips.map((tip) => (
				<BettingTypeColumnTip key={tip} tip={tip} />
			))}
		</>
	);
}
